import React, {useContext} from 'react';
import './SettingsGeneral.less';
import {ProfilePickerTrigger} from "elements/profile-picker-trigger/ProfilePickerTrigger";
import {ProfilePicker} from "compositions/profile-picker/ProfilePicker";
import {List} from "elements/list/List.tsx";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const SettingsGeneral = ({
																	currentLanguage,
																	onLanguageClick,
																	notificationCount = 0,
																	onNotificationClick
																}) => {
	const translations = useContext(TranslationsContext);

	return <List>
		<ListItem key="language" onClick={onLanguageClick} isResponsive>
			<ProfilePicker title={getSafeTranslation('SettingsGeneral.languageLabel', translations)}>
				<ProfilePickerTrigger text={currentLanguage}/>
			</ProfilePicker>
		</ListItem>
		<ListItem key="notifications" onClick={onNotificationClick} isResponsive>
			<ProfilePicker title={getSafeTranslation('SettingsGeneral.notificationsLabel', translations)}>
				<ProfilePickerTrigger
					text={getSafeTranslation('SettingsGeneral.notificationsValue', translations).replace('{notificationCount}', notificationCount)}/>
			</ProfilePicker>
		</ListItem>
	</List>
}
